<template>
  <div class="auth-wrapper auth-v1">
    <b-row class="auth-inner m-0">

      <!-- Login-->
      <b-col
        lg="12"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="12"
          md="12"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <div
            style="text-align:center; margin-top:-50px;"
          >
            <b-img
              style="width:150px;"
              :src="require(`@/assets/images/partner/${partner}/logo/logo.png`)"
            />
            <br><br><br><br>
          </div>
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          > Login
          </b-card-title>
          <b-card-text class="mb-2">
            Bitte melden Sie sich in Ihrem Konto an
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Einmalpasswort</label>
                <!--
                 <b-link :to="{name:'forgot-password'}">
                    <small>Passwort vergessen?</small>
                  </b-link>
                  -->
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Einmalpasswort"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-alert
                v-if="showAlert"
                variant="danger"
                show
              >
                <h4 class="alert-heading">
                  Fehler
                </h4>
                <div class="alert-body">
                  <span>{{ alertText }}</span>
                </div>
              </b-alert>

              <!-- submit buttons -->
              <b-button
                type="submit"
                :variant="partnerData.colorScheme"
                block
                @click="validationForm"
              >
                LOGIN
              </b-button>
            </b-form>
          </validation-observer>
          <b-card-text class="text-left mt-2">
            <span>Noch nicht registriert?</span>
            <b-link
              :to="{name:'register'}"
              :style="getHrefStyle()"
            >
              <span>&nbsp;Registrierung</span>
            </b-link>
            <br>
            <span>Sie haben bereits ein Konto?</span>
            <b-link
              :to="{name:'login'}"
              :style="getHrefStyle()"
            >
              <span>&nbsp;Anmeldung</span>
            </b-link>
            <br>
            <span>FIN vergessen?</span>
            <b-link
              :to="{name:'otp-request'}"
              :style="getHrefStyle()"
            >
              <span>&nbsp;Einmalpasswort erneut zusenden</span>
            </b-link>
          </b-card-text>
        </b-col>
        <div
          style="position: absolute; bottom: 0; right: 0px; font-size:12px; color:#5e587 !important;"
        >
          <b-button
            :to="{name:'impressum'}"
            variant="flat-secondary"
            size="sm"
          >
            Impressum
          </b-button>
        </div>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BCardText,
  BCardTitle,
  BForm,
  BButton,
  BAlert,
  BImg,
} from 'bootstrap-vue'

import { ref } from '@vue/composition-api'

import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import jwtDecode from 'jwt-decode'
import store from '@/store/index'
//  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/auth/jwt/useJwt'
import router from '@/router'

localize('de')
export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BAlert,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      showAlert: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    getUserAbility() {
      const managerAbility = [
        {
          action: 'manage',
          subject: 'Users',
        },
        {
          action: 'manage',
          subject: 'Dashboard',
        },
        {
          action: 'manage',
          subject: 'Auth',
        },
      ]

      return managerAbility
    },
    getMangerAbility() {
      const managerAbility = [
        {
          action: 'manage',
          subject: 'Dashboard',
        },
        {
          action: 'manage',
          subject: 'Users',
        },
        {
          action: 'manage',
          subject: 'SolarPlant',
        },
        {
          action: 'manage',
          subject: 'Auth',
        },
      ]

      return managerAbility
    },
    getAdminAbility() {
      const adminAbility = [
        {
          action: 'manage',
          subject: 'all',
        },
      ]

      return adminAbility
    },
    validationForm() {
      //  This is temp only, do logic first!
      //  this.$router.push('/')
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.showAlert = false

          useJwt.loginOtp({
            username: this.userEmail,
            password: this.password,
          })
            .then(response => {
              console.log('response.data', response.data)

              if (response.status === 200) {
                useJwt.setToken(response.data.accessToken)
                useJwt.setRefreshToken(response.data.refreshToken)

                const token = response.data.accessToken
                const decodedToken = jwtDecode(token)

                let userLevel = 'user'

                let userAbility = []
                if (decodedToken.realm_access.roles.includes('user')) {
                  userAbility = this.getUserAbility()
                }

                if (decodedToken.realm_access.roles.includes('manager')) {
                  userAbility = this.getMangerAbility()
                  userLevel = 'manager'
                }

                if (decodedToken.realm_access.roles.includes('admin')) {
                  userAbility = this.getAdminAbility()
                  userLevel = 'admin'
                }

                const userData = {
                  //  id: decodedToken.sub,
                  //  uid: decodedToken.sid,
                  id: response.data.userId,
                  cid: response.data.carId,
                  fullName: `${response.data.firstName} ${response.data.lastName}`,
                  username: decodedToken.preferred_username,
                  avatar: '',
                  email: decodedToken.email,
                  ability: userAbility,
                  firstName: response.data.firstName,
                  lastName: response.data.lastName,
                  userLevel,
                }

                /*
                console.log('decodedToken', decodedToken)
                console.log('userData', userData)
                */

                //  window.$cookies.set('userData', userData, '1D')
                //  window.$cookies.set('userData', userData, Infinity, null, null, true, 'None')
                window.$cookies.set('userData', userData, '1D', null, null, true, 'None')

                window.sessionStorage.setItem('activeTime', Date.now())

                // Updating user ability in CASL plugin instance
                this.$ability.update(userData.ability)
                this.$router.go('/')
              }
            })
            .catch(error => {
              console.log(error)
              this.showAlert = true
              this.alertText = 'Ihre Einmalpasswort ist ungültig.'
            })
        }
      })
    },
  },
  setup() {
    const partner = ref(window.$cookies.get('partner'))
    const partnerData = ref(JSON.parse(localStorage.getItem('partnerData')))
    const getHrefStyle = () => `color:var(--${partnerData.value.colorScheme})`
    document.title = partnerData.value.htmlPageTitle
    document.querySelector("link[rel*='icon']").href = `favicon_${partnerData.value.key}.ico`

    const appIdElem = document.getElementById('app')
    let backgroundImage = ''
    if (typeof (window.$cookies.get('partner')) !== 'undefined') {
      backgroundImage = require(`@/assets/images/partner/${partner.value}/backgorund/auth.jpg`)
      appIdElem.style.backgroundImage = `url('${backgroundImage}')`
    }

    // fallback
    if (partnerData.value === null) {
      router.push('/partner/ladestellenbonus/login')
    }

    const alertText = ref('')
    const status = ref('')
    const password = ref('')
    const userEmail = ref('')

    const decodedString = Buffer.from(router.currentRoute.params.otp, 'base64').toString()

    const optData = decodedString.split('|')

    userEmail.value = optData['0']
    password.value = optData['1']

    return {
      partner,
      partnerData,
      getHrefStyle,
      alertText,
      status,
      password,
      userEmail,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
